import { graphql } from 'react-relay';

export const deniedPageFragment = graphql`
  fragment DeniedPage_page on Page {
    id
    path
    breadcrumbs {
        ...Breadcrumb_data
    }
  }
`;
